<template>
  <div>
    <br />
    <b-row>
      <b-col cols="2">
        <b-form-group label="ID Original">
          <b-form-input
            type="text"
            size="sm"
            placeholder="ID Original"
            v-model="form.channel_id"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Demais ID">
          <b-form-input
            type="text"
            size="sm"
            placeholder="Demais ID"
            v-model="form.external"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Canal">
          <b-form-select
            size="sm"
            :options="oprtions_available_channels"
            v-model="form.channel"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="PluggID">
          <b-form-input
            type="text"
            size="sm"
            placeholder="Plugg ID"
            v-model="form.id"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="SKU ou EAN">
          <b-form-input
            type="text"
            size="sm"
            placeholder="SKU ou EAN"
            v-model.trim="form.sku"
            v-on:change="autoFilter()"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col
        v-show="!faCaret"
        cols="2"
        class="text-center"
        style="margin-top: 27px"
      >
        <b-button size="sm" variant="success" @click="filter()">
          Buscar
        </b-button>
        <b-button size="sm" variant="light" @click="filterClear">
          Limpar
        </b-button>
      </b-col>
      <b-col v-show="faCaret" cols="2">
        <b-form-group label="Nome do cliente">
          <b-form-input
            type="text"
            size="sm"
            placeholder="Primeiro nome"
            v-model="form.payer_name"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="faCaret">
      <b-col cols="2">
        <b-form-group label="SLA's">
          <b-form-select size="sm" v-model="form.sla" :options="options_slas">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Por conta">
          <b-form-select
            size="sm"
            v-model="form.channel_account"
            :options="options_por_conta"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Tipo de entrega">
          <b-form-select
            size="sm"
            v-model="form.delivery_type"
            :options="options_tipo_entrega"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Tipo de etiqueta">
          <b-form-select
            size="sm"
            v-model="form.label_type"
            :options="options_tipo_etiqueta"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Data">
          <b-form inline>
            <b-form-input
              type="date"
              size="sm"
              v-model="form.datestart"
            ></b-form-input>
            <b-form-input
              type="date"
              size="sm"
              v-model="form.dateend"
            ></b-form-input>
          </b-form>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Sobrenome do cliente">
          <b-form-input
            type="text"
            size="sm"
            placeholder="Sobrenome"
            v-model="form.payer_lastname"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="faCaret">
      <b-col class="text-right" style="margin-top: 27px">
        <b-button size="sm" variant="success" @click="filter()">
          Buscar
        </b-button>
        <b-button size="sm" variant="light" @click="filterClear">
          Limpar
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <b-button size="sm" variant="light" @click="faCaret = !faCaret">
          <i :class="faCaret ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i>
          {{ faCaret ? "Minimizar os filtros" : "Mostrar todos os filtros" }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import barramento from "../../../barramento";
export default {
  props: ["expedition", "options_por_conta", "oprtions_available_channels"],
  data() {
    return {
      faCaret: false,
      form: {
        channel_id: null,
        external: null,
        nfe_key: null,
        channel: null,
        id: null,
        sku: null,
        status: null,
        sub_status: null,
        sla: null,
        channel_account: null,
        delivery_type: null,
        datestart: null,
        dateend: null,
        payer_name: null,
        payer_lastname: null,
        label_type: null,
        p_open: true,
        has_invoice_pdf: null,
        label: null,
      },
      options_status: [
        { value: null, text: "Selecione o status..." },
        { value: "pending", text: "Pendente" },
        { value: "paid", text: "Pago" },
        { value: "approved", text: "Aprovado" },
        { value: "partial_payment", text: "Pagamento parcial" },
        { value: "shipping_informed", text: "Entrega informada" },
        { value: "waiting_invoice", text: "Nota fiscal solicitada" },
        { value: "picking", text: "Em separação" },
        { value: "invoiced", text: "Faturado" },
        { value: "invoice_error", text: "Erro ao gerar nota fiscal" },
        { value: "shipped", text: "Em Trânsito" },
        { value: "shipping_error", text: "Erro ao enviar entrega" },
        { value: "delivered", text: "Entregue" },
        { value: "canceled", text: "Cancelado" },
        { value: "under_review", text: "Sob análise" },
      ],
      options_slas: [
        { value: null, text: "Selecione o slas..." },
        { value: "expiredSendSla", text: "Envio expirado" },
        { value: "expiredDeliverySla", text: "Entrega expirada" },
        { value: "sendToday", text: "Enviar Hoje" },
      ],
      options_tipo_entrega: [
        { value: null, text: "Selecione o tipo de entraga..." },
        { value: "standard", text: "Padrão" },
        { value: "express", text: "Expressa" },
        { value: "onehour", text: "Motoboy" },
        { value: "pickup", text: "Retirada" },
        { value: "economy", text: "Econômica" },
        { value: "guaranteed", text: "Garantida" },
        { value: "scheduled", text: "Agendada" },
        { value: "fastshipping", text: "Coleta Rápida" },
        { value: "international", text: "Internacional" },
        { value: "fulfillment", text: "Fulfillment" },
      ],
      options_tipo_etiqueta: [
        { value: null, text: "Selecione o tipo..." },
        { value: "manual", text: "Manual" },
        { value: "third_contract", text: "Etiqueta do MarketPlace" },
        { value: "fulfillment", text: "Fulfillment" },
        { value: "own_contract", text: "Contrato Próprio" },
        { value: "pickup_store", text: "Retirada" },
        { value: "drop_shipping", text: "Envio pelo Fornecedor" },
      ],
      autoFilterTimeout: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.autoFilterTimeout);
    barramento.$off("loading_filters");
  },
  created() {
    barramento.$on("loading_filters", () => {
      this.filter();
    });
  },
  methods: {
    normalizeSkuFilter() {
      if (typeof this.form.sku === "string") {
        this.form.sku = this.form.sku.trim();
      }
    },
    autoFilter(){
      this.normalizeSkuFilter();
      clearTimeout(this.autoFilterTimeout);
      if(this.expedition.expedition == 'pronto_para_embalar' && this.form.sku && this.form.sku.length > 3){
          this.autoFilterTimeout = setTimeout(() => this.filter(), 1000);
      }
    },
    filter() {
      this.normalizeSkuFilter();
      this.form.status = this.expedition.filters.status;
      this.form.sub_status = this.expedition.filters.sub_status;
      
      if(this.expedition && this.expedition.expedition == 'pronto_para_embalar'){
        this.form.needsEan = this.expedition.filters.needsEan;
        this.form.has_label = this.expedition.filters.has_label;
        this.form.delivery_type = this.expedition.filters.delivery_type;
      }

      let newObj = {};
      let object = this.form;
      Object.keys(object).forEach((prop) => {
        if (object[prop]) {
          newObj[prop] = object[prop];
        }
      });
      barramento.$emit("orders_filters", newObj);
      barramento.$emit(this.expedition.expedition, newObj);
    },
    filterClear() {
      this.form.channel_id = null;
      this.form.external = null;
      this.form.nfe_key = null;
      this.form.channel = null;
      this.form.id = null;
      this.form.sku = null;
      this.form.status = this.expedition.filters.status;
      this.form.sub_status = this.expedition.filters.sub_status;
      this.form.sla = null;
      this.form.channel_account = null;
      this.form.delivery_type = null;
      this.form.datestart = null;
      this.form.dateend = null;
      this.form.payer_name = null;
      this.form.payer_lastname = null;
      this.form.label_type = null;

      this.has_invoice_pdf = null;
      this.label = null;
      barramento.$emit(this.expedition.expedition, null);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/Filter.vue